module.exports = __webpack_public_path__ + "assets/8d578a7f75133c71a280e49125586ca5.svg";